declare var require: any;
export const environment = {
  test: false,
  stage: false,
  production: true,
  app: {
    name: 'Bockmann',
    version: require('../../package.json').version,
  },
  serverUrl: 'https://boeckmann-configurator-backend-live.azurewebsites.net',
};
